'use client';

import { getIn } from 'formik';
import TextInput from '@/components/core/TextInput';
import { ForwardedRef, forwardRef, useEffect } from 'react';

type Props = {
    field: Record<any, any>;
    form: Record<any, any>;
    onErrorChange: () => null;
    error: boolean;
    hint: string;
    hintOnBlur: boolean;
} & Record<any, any>

const FormikTextInput = forwardRef((
    { field, form, onErrorChange = () => null, error, className, hint, hintOnBlur = true, ...props }: Partial<Props>,
    forwardedRef: ForwardedRef<HTMLInputElement>
) => {
    const touched = getIn(form?.touched, field?.name);
    const formError = getIn(form?.errors, field?.name);

    useEffect(() => {
        onErrorChange && onErrorChange();
    }, [formError, touched]);

    return (
        <TextInput
          error={error !== undefined ? error : (touched && !!formError)}
          hint={hint !== undefined ? hint : (touched && formError)}
          ref={forwardedRef}
          rootClassName={className}
          onBlur={() => {
              if (hintOnBlur) {
                  form?.setFieldTouched(field?.name, true, true);
              }

              props.onBlur && props.onBlur();
          }}
          {...field}
          {...props}
        />
    );
});

FormikTextInput.displayName = 'FormikTextInput';

export default FormikTextInput;
